import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import Header from './Components/Header';
import Homepage from './Components/Homepage';
import ProjectCaseStudy from './Components/ProjectCaseStudy';

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return <div className="app-shell"><ScrollToTop /><Header /><Routes><Route path="/" element={<Homepage />} /><Route path="/project/:slug" element={<ProjectCaseStudy />} /><Route path="*" element={<ProjectCaseStudy />} /></Routes></div>;
}

export default App;
